import { useRouter } from 'next/router';

export const useQuizsetId = () => {
  const {
    query: { id },
  } = useRouter();
  return id as string;
};
